import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  visible: false,
  triggerOverrides: null,
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setChatVisible: (state, action) => {
      state.visible = action.payload;
    },
    setChatTriggerOverrides: (state, action) => {
      state.triggerOverrides = action.payload;
    },
    clearChatTriggerOverrides: (state) => {
      state.triggerOverrides = null;
    },
  },
});

export const {
  setChatVisible,
  setChatTriggerOverrides,
  clearChatTriggerOverrides,
} = chatSlice.actions;

export default chatSlice.reducer;
